<script setup lang="ts">
  import { Icon, IconName, IconSize, Input } from '@travelata-libs/ui-kit';
  import { computed } from 'vue';

  interface DestinationSearchInputProps {
    modelValue?: string;
    placeholder?: string;
  }

  const props = withDefaults(defineProps<DestinationSearchInputProps>(), {
    modelValue: '',
    placeholder: '',
  });

  interface DestinationSearchInputEmits {
    (e: 'update:modelValue', value: string): void;
    (e: 'focus'): void;
    (e: 'blur'): void;
  }

  const emit = defineEmits<DestinationSearchInputEmits>();

  const hasQuery = computed<boolean>(() => props.modelValue.trim() !== '');

  const onInput = (value: string): void => {
    emit('update:modelValue', value);
  };

  const clear = (): void => {
    onInput('');
  };
</script>

<script lang="ts">
  export default {
    model: {
      prop: 'modelValue',
      event: 'update:modelValue',
    },
  };
</script>

<template>
  <Input
    class="destination-search-input"
    :model-value="modelValue"
    :placeholder="placeholder"
    :bg="false"
    bordered
    size="l"
    name="destination-mobile-search"
    data-testid="destination-mobile-search"
    @update:modelValue="onInput"
    @focus="emit('focus')"
    @blur="emit('blur')"
  >
    <template #append>
      <button
        v-if="hasQuery"
        type="button"
        class="destination-search-input__icon-btn"
        data-testid="destination-mobile-search-clear"
        aria-label="Очистить"
        @click.stop.prevent="clear"
      >
        <Icon
          :name="IconName.Close"
          :size="IconSize.S"
        />
      </button>
      <Icon
        v-else
        :name="IconName.Search"
        :size="IconSize.S"
        class="destination-search-input__icon"
      />
    </template>
  </Input>
</template>

<style scoped lang="scss">
  .destination-search-input {
    &__icon {
      fill: var(--color-text-secondary);
    }

    &__icon-btn {
      align-items: center;
      background: none;
      border: none;
      cursor: pointer;
      display: inline-flex;
      fill: var(--color-text-secondary);
      justify-content: center;
      padding: 0;
    }
  }
</style>
